export enum OrganizationTabsKeys {
  PROPERTIES = 'PROPERTIES',
  USERS = 'USERS',
  INTERNAL_SALE_TEAM = 'INTERNAL_SALE_TEAM',
}

export const DEFAULT_ORGANIZATION_TAB_KEY = OrganizationTabsKeys.PROPERTIES;
